import { http } from "../../../shared/services/http.service";
import { UpdateUserModel } from "../models/update-user.model";

export const updateUserApi = async (data: UpdateUserModel) =>
  http({ url: "user", method: "POST", auth: true, data });

export const meApi = () => http({ url: "user", method: "GET", auth: true });
